import React, { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";
import { useMutation } from "react-query";
import { Input, Select, Button, InputNumber, Collapse, Space, DatePicker } from "antd";
import { PaymentLinkContext } from "../../../context/PaymentLinkContext";
import { PlusOutlined, LinkOutlined, MinusOutlined } from "@ant-design/icons";
import { createPaymentLink } from "../service/api";
import '../utils/modalCreateLink.css';
import toast from "react-hot-toast";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { useQueryClient } from "react-query";
import { formatDatePaymentLinkToSend } from "../utils/script/indexUtils";


const { Panel } = Collapse;

const CreateLinkForm = ({ onLinkCreated, closeModal, selectedBusiness, action }) => {

  // Récupérer l'éventuel lien de paiement
  const { businessName, link, amount, type, frequency, clientEmails, nextPaymentDate, description, startDate, active } = selectedBusiness || {};
console.log('selectedBusiness', selectedBusiness)

  // Variable de session
  const currentUser = JSON.parse(sessionStorage.getItem('authUser'));

  const { contactList } = useContext(PaymentLinkContext);

  // Variable d'état
  const [recipients, setRecipients] = useState(false);
  const [isAddDestinatorOpen, setIsAddDestinatorOpen] = useState(false);

  const queryClient = useQueryClient();

  // Mutations
  const createLinkMutation = useMutation(createPaymentLink);


  const togglePanel = () => {
    setIsAddDestinatorOpen(!isAddDestinatorOpen)
  }

  const contacts = contactList?.map((contact) => ({
    value: contact.email,
    label: contact.fullName
  }));

  const validationSchema = Yup.object().shape({
    description: Yup.string()
      .required('La description du lien est obligatoire'),
    amount: Yup.number()
      .required('Le montant est obligatoire')
      .positive('Le montant doit être positif'),
    paymentLinkExpiration: Yup.date()
      .required("La date d'expiration  est obligatoire")
      .min(new Date(), "La date ne doit pas être passée")

  });

  const formik = useFormik({
    initialValues: {
      description: '',
      amount: null,
      paymentLinkExpiration: '',
      fullName: '',
      clientEmail: '',
      /* frequency: '', */
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      
      const data = {
        token : currentUser?.token,
        userId : currentUser?.userId,
        businessId : selectedBusiness?.id,
        ...values,
      }
      createLinkMutation.mutate(data, {
        onSuccess: (response) => {
          toast.success("Lien de paiement créé avec succès.");
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey[0] === 'paymentLinks',
          });
          closeModal();
        },
        onError: (error) => {
          console.error(error);
          closeModal();
          toast.error("Erreur lors de la création.")
        }
      })
      resetForm();
    },

    onReset: () => {
      formik.setErrors({});
      console.log('Form reset');
    },
  });


  return (
    <div className="container-create-link">
      <div className="title-h2-payment-link">{action} un nouveau lien</div>
      <p className="normal-text mt-1">
        Générez facilement un lien de paiement en un clic, partagez-le et recevez vos fonds une fois le règlement effectué.
      </p>
      <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
        <div className="form-container-create-link">
          <label>Description du lien</label>
          <Input
            name="description"
            placeholder="Description"
            value={formik.values.description}
            onChange={formik.handleChange}
          />
          {formik.touched.description && formik.errors.description && (
            <div className="error-form-create-link">{formik.errors.description}</div>
          )}
          <div className="mt-2">
            <label>Montant du lien</label>
            <InputNumber
              name="amount"
              addonAfter="XOF"
              placeholder="Saisir le montant ici"
              value={formik.values.amount}
              onChange={(value) => formik.setFieldValue('amount', value)}
              style={{ width: '100%' }}
            />
          </div>
          {formik.touched.amount && formik.errors.amount && (
            <div className="error-form-create-link">{formik.errors.amount}</div>
          )}
          <div>
            <label className="d-block mt-2">Date d'expiration</label>
            <DatePicker
              name="expirationDate"
              className="w-100"
              placeholder="Choisir la date d'expiration"
              value={formik.values.paymentLinkExpiration ? dayjs(formik.values.paymentLinkExpiration) : null}
              onChange={(date) => formik.setFieldValue('paymentLinkExpiration', date ? formatDatePaymentLinkToSend(date) : null)}
              disabledDate={(current) => {
                const today = dayjs().startOf('day');
                return current && current < today;
              }}
            />
            {formik.touched.paymentLinkExpiration && formik.errors.paymentLinkExpiration && (
              <div className="error-form-create-link">{formik.errors.paymentLinkExpiration}</div>
            )}
          </div>
        </div>

        <div className="recipients-container mt-2">
          <div style={{ flex: 1 }}>
            <div className="form-group">
              <label htmlFor="recipient">Destinataire</label>
              <Select
                id="recipient"
                className="w-100"
                showSearch
                placeholder="Sélectionner un destinataire"
                optionFilterProp="label"
                value={formik.values.recipient}
                onChange={(value) => {
                  formik.setFieldValue('recipient', value);
                  setRecipients(true);
                }}
                options={contacts}
                disabled={isAddDestinatorOpen}
              />
            </div>

            <div>
              <Button
                icon={isAddDestinatorOpen ? <MinusOutlined /> : <PlusOutlined />}
                type="text"
                className="add-destinator-button"
                onClick={togglePanel}
                disabled={recipients}
              >
                Ajouter un autre destinataire
              </Button>

              <Collapse activeKey={isAddDestinatorOpen ? ['1'] : []} ghost>
                <Panel key="1" showArrow={false} header={null}>
                  <Space direction="vertical" className="w-100">
                    <Input
                      name="fullName"
                      placeholder="Nom du destinataire"
                      value={formik.values.fullName}
                      onChange={formik.handleChange}
                    />
                    <Input
                      name="clientEmail"
                      placeholder="Email du destinataire"
                      value={formik.values.clientEmail}
                      onChange={formik.handleChange}
                    />
                  </Space>
                </Panel>
              </Collapse>
            </div>
          </div>
        </div>
        <div className="action-buttons">
          <Button
            type="primary"
            className={`create-link ${createLinkMutation.isLoading ? "loading" : ""}`}
            htmlType="submit"
            disabled={createLinkMutation.isLoading}
            icon={
              createLinkMutation.isLoading ? (
                <span className="loader" />
              ) : (
                <LinkOutlined />
              )
            }
          >
            {createLinkMutation.isLoading ? "Création en cours..." : "Créer le lien"}
          </Button>
          <Button type="text" className="cancel-button" onClick={closeModal} htmlType="reset">
            Annuler
          </Button>
        </div>
      </form>

    </div>
  );
};

export default CreateLinkForm;
